if(!customElements.get('pagination-button')){
    class ProductListPaginationButton extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnLoadMore = this.querySelector('.btn-load-more');

            if(this.closest('custom-search-product-list')){

                this.productList = this.closest('custom-search-product-list');
                this.productsWrapper = this.productList.querySelector('#search-item-list__items-wrapper');
                this.products = this.productList.querySelector('#search-item-list__items');
                this.content = 'search';

            }else if(this.closest('custom-collection-product-list')){

                this.productList = this.closest('custom-collection-product-list');
                this.productsWrapper = this.productList.querySelector('#collection-product-list__products-wrapper');
                this.products = this.productList.querySelector('#collection-product-list__products');
                this.content = 'collection';

            }
            
            this.btnColumnSwitch = this.productList.querySelector('.product-view-switch-wrapper');

            this.btnLoadMore.addEventListener('click', e => {
                e.preventDefault();

                this.btnLoadMore.setAttribute('data-disabled', 'true');
                this.loadMoreProducts();
            });

            this.btnLoadMore.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    e.preventDefault();

                    this.btnLoadMore.setAttribute('data-disabled', 'true');
                    this.loadMoreProducts();
                }
            })
        }

        async loadMoreProducts(){
            try{
                const nextPageRes = await fetch(
                    `${this.btnLoadMore.dataset.url}`
                );
                const nextPageText = await nextPageRes.text();
                const nextPageHTML = new DOMParser().parseFromString(nextPageText, 'text/html');

                const productsWrapper = this.content == 'collection'? 
                    nextPageHTML.querySelector('#collection-product-list__products-wrapper'):
                    nextPageHTML.querySelector('#search-item-list__items-wrapper');

                const products = this.content == 'collection'? 
                    productsWrapper.querySelector('#collection-product-list__products'):
                    productsWrapper.querySelector('#search-item-list__items');

                const btnLoadMore = productsWrapper.querySelector('.btn-load-more');

                // get product 
                const productCards = products.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper');

                // Neem de kolom-classes over van een reeds gerenderde kaart,
                // zodat naladen exact dezelfde layout houdt als pagina 1.
                const referenceCard = this.products.querySelector('.product-card__wrapper');
                let colClasses = [];
                if(referenceCard){
                    colClasses = Array.from(referenceCard.classList).filter(c => c.indexOf('col-') === 0);
                }

                productCards.forEach(item => {
                    if(colClasses.length > 0){
                        // verwijder eventuele col-classes uit de opgehaalde kaart
                        Array.from(item.classList)
                            .filter(c => c.indexOf('col-') === 0)
                            .forEach(c => item.classList.remove(c));
                        // en zet de classes van de bestaande kaarten erop
                        colClasses.forEach(c => item.classList.add(c));
                    }
                    this.products.appendChild(item);
                });

                if (productCards.length > 0) {
                    setTimeout(() => {
                        if(productCards[0].querySelectorAll('.tab-able-item').length > 0){
                            productCards[0].querySelectorAll('.tab-able-item')[0].focus();
                        }
                    }, 100);
                }

                if(btnLoadMore){
                    this.btnLoadMore.classList.remove('d-none');
                    this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                }else{
                    this.btnLoadMore.classList.add('d-none');
                }

                // add swatch checked
                const variantSwatchSelector = this.products.querySelectorAll('variant-swatch-selector');
                if(variantSwatchSelector.length > 0){
                    variantSwatchSelector.forEach(item => {
                        item.loadCheckedRadioInput();
                    });
                }
            } catch (error){

                console.error(error);
                alert(error.message);

            } finally {
                this.btnLoadMore.setAttribute('data-disabled', 'false');
            }
        }
    }

    customElements.define('pagination-button', ProductListPaginationButton);
}
